/**
 * Created by alex.y on 9/7/2017.
 */
export class BlurUtil {

    public static blurMenu(id: string): void {
        let leftMenu = document.getElementById("left-sidebar");
        let topMenu = document.getElementById("navbar-top");
        let content = document.getElementById(id);

        if(leftMenu)
        leftMenu.className = leftMenu.className + " blur-content";
        if(topMenu)
        topMenu.className = topMenu.className + " blur-content";


        if(content)
            content.className = content.className + " blur-content"
    }

    public static unBlurMenu(id: string): void {
        let leftMenu = document.getElementById("left-sidebar");
        let topMenu = document.getElementById("navbar-top");
        let content = document.getElementById(id);

        if(leftMenu)
        leftMenu.className = leftMenu.className.replace("blur-content", "");
        if(topMenu)
        topMenu.className = topMenu.className.replace("blur-content", "");

        if(content)
            content.className = content.className.replace("blur-content", "");
    }
}


// WEBPACK FOOTER //
// ./app/common/utils/blurUtil.ts